import Component from './component'

import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    console.log(state.ui.loading,'yoooooooooooooo');
    return {
        loading: (state.ui.loading.que>0? state.ui.loading.isloading? 'loading_now' : 'finished' : null)
    }
}

export default connect(mapStateToProps)(Component)


// WEBPACK FOOTER //
// ./src/views/loadingbar/container.js